require("./toaster.js");
module.exports = "toaster";



/*****************
 ** WEBPACK FOOTER
 ** ./~/angularjs-toaster/index.js
 ** module id = 390
 ** module chunks = 0
 **/